import React from "react";

type State = { hasError: boolean; info?: string };
export default class ErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = { hasError: false };
  static getDerivedStateFromError(err: unknown) { return { hasError: true, info: String(err) }; }
  componentDidCatch(err: unknown, info: any) { console.error("ErrorBoundary", err, info); }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24, fontFamily: "ui-sans-serif" }}>
          <h1 style={{ fontWeight: 600 }}>App error</h1>
          <pre style={{ whiteSpace: "pre-wrap" }}>{this.state.info}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}
